import { render, staticRenderFns } from "./CadastroPageHeader.vue?vue&type=template&id=10c61d5e&scoped=true&lang=pug&"
import script from "./CadastroPageHeader.vue?vue&type=script&lang=js&"
export * from "./CadastroPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPageHeader.vue?vue&type=style&index=0&id=10c61d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c61d5e",
  null
  
)

export default component.exports